module.exports = __webpack_public_path__ + "img/901504927.79a50839.png";